<form (ngSubmit)="submit()" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
  <image-uploader [initialImageURL]="logo?.url" (imageSelected)="onImageChanged($event)"></image-uploader>
  <button mat-raised-button color="accent" type="submit">{{ 'upload' | translate }}</button>
  <i>{{ 'recommendedSize' | translate }} {{ type.size }}</i>
</form>